import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ClickSpark from './components/ClickSpark';
import Navbar from './components/common/Header/Navbar';
import Footer from './components/common/Footer/Footer';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Services from './pages/Services/Services';
import Contact from './pages/Contact/Contact';
import BbpsApis from './pages/Bbps_api/BbpsApis';
import KycApis from './pages/KycApis/KycApis';
import PrivacyPolicy from './pages/Privacypolicy/PrivacyPolicy';
import DomainAPI from './pages/Domain_api/domain_Api';
import TravelBookingApis from './pages/Travel_Api/TravelBookingApis';
import TermsAndConditions from './pages/TermsAndCondition/TermsAndConditions';


function App() {
  return (
    <ClickSpark>
      <Router>
        <Navbar style={{ marginBottom: '100px' }}  />
        <main className="min-h-screen mt-5">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/BbpsApis" element={<BbpsApis />} />
            <Route path="/KycApis" element={<KycApis />} />
            <Route path="/Contact" element={<Contact />} />
             <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
             <Route path="/TermsAndConditions" element={<TermsAndConditions />} />

            <Route path="/domain_api" element={<DomainAPI />} />
            <Route path="/travel_api" element={<TravelBookingApis />} />
            

          </Routes>
        </main>
        <Footer />
      </Router>
    </ClickSpark>
  );
}

export default App;
